<template>
  <div class="uploader" :class="{ open: dialogOpen }">
    <input ref="imgInput" @change="imageLoaded" accept="image/*" name="image" type="file" />

    <div id="uploadDialog" v-show="dialogOpen">
      <div class="voileNoir" @click="close" />
      <div class="contenu">
        <div ref="cadre" class="cadre" />

        <div id="boutonsUpload" class="contenuPanel">
          <a id="boutonEnvoi" @click.prevent="saveClicked" enabled="true" class="bouton">
            Enregistrer
          </a>

          <div id="icones">
            <a id="boutonPortrait" @click.prevent="setPortrait" title="Portrait" enabled="true" class="imageBouton">
              <img
                :class="{ enabled: paysage === false }"
                :src="'/assets/icons_' + $store.state.iconTheme + '/portrait.png'"
              />
            </a>
            <a id="boutonPaysage" @click.prevent="setPaysage" title="Paysage" enabled="true" class="imageBouton">
              <img
                :class="{ enabled: paysage === true }"
                :src="'/assets/icons_' + $store.state.iconTheme + '/paysage.png'"
              />
            </a>
            <a id="boutonRotation" @click.prevent="rotate90" title="Rotation" enabled="true" class="imageBouton">
              <img :src="'/assets/icons_' + $store.state.iconTheme + '/rotate.png'" class="enabled" />
            </a>
          </div>
        </div>
      </div>
      <label id="paysageWarning" v-if="paysage">
        <img :src="'/assets/icons_' + $store.state.iconTheme + '/warning.png'" />
        Une photo au format paysage ne pourra pas être utilisée comme photo de profil.
      </label>
    </div>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.min.css";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

const loadImage = require("blueimp-load-image-npm");

export default {
  name: "ImageUploader",
  props: {
    label: {
      type: String,
      default: null
    },
    profile: {
      type: Object,
      default: null
    },
    linkClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogOpen: false,
      lastLoadedImage: null,
      MAX_HEIGHT: 650,
      MAX_WIDTH: 650,
      paysage: false,
      cropper: null,
      imageCanvas: null,
      rotationIndex: 0,
      rotation: 0
    };
  },

  computed: {
    ratio: function() {
      if (this.paysage === true) return 300 / 225;
      else return 225 / 300;
    },

    type: function() {
      if (this.paysage === true) return 1;
      return 0;
    }
  },

  created: function() {
    this.initMaxSize();
  },

  methods: {
    initMaxSize: function() {
      this.MAX_HEIGHT = window.innerHeight - 180;
      this.MAX_WIDTH = window.innerWidth - 20;
    },

    open: function() {
      this.$refs.imgInput.click();
    },

    imageLoaded: function() {
      const thisObj = this;

      this.initMaxSize();
      this.rotation = 0;
      loadImage(
        this.$refs.imgInput.files[0],
        function(canvas) {
          thisObj.redrawImage(canvas);
        },
        {
          maxWidth: this.MAX_WIDTH,
          maxHeight: this.MAX_HEIGHT,
          orientation: true
        }
      );
    },

    redrawImage: function(canvas) {
      if (this.imageCanvas != null) this.imageCanvas.remove();
      this.imageCanvas = canvas;
      this.$refs.cadre.appendChild(this.imageCanvas);
      this.imageCanvas.ref = "canvasProfil";
      this.imageCanvas.id = "canvasProfil";
      this.dialogOpen = true;
      this.crop();
    },

    prevent: function(e) {
      e.preventDefault();
      e.stopPropagation();
    },

    close: function() {
      this.dialogOpen = false;
      this.$refs.imgInput.value = "";
    },

    saveClicked: async function() {
      this.$store.state.loading = true;
      await this.send();
      this.$store.state.loading = false;
      this.close();
    },

    updateRatio: function() {
      if (this.cropper != null) this.cropper.setAspectRatio(this.ratio);
    },

    setPortrait: function() {
      this.paysage = false;
      this.updateRatio();
    },

    setPaysage: function() {
      this.paysage = true;
      this.updateRatio();
    },

    rotate90: function() {
      const thisObj = this;

      this.rotationIndex++;
      this.rotationIndex %= 4;
      this.imageCanvas.toBlob(function(blob) {
        loadImage(
          blob,
          canvas => {
            thisObj.redrawImage(canvas);
          },
          {
            orientation: 6,
            maxWidth: thisObj.MAX_WIDTH,
            maxHeight: thisObj.MAX_HEIGHT
          }
        );
      });
    },

    crop: function() {
      if (this.cropper != null) this.cropper.destroy();
      this.setPortrait();

      this.cropper = new Cropper(this.imageCanvas, {
        aspectRatio: this.ratio,
        scalable: false,
        zoomable: false
      });
    },

    send: async function() {
      const imageData = this.imageCanvas.toDataURL();

      const pic = await idyuJsonRpc(
        "uploadPicture",
        imageData,
        Math.round(this.cropper.getData().x),
        Math.round(this.cropper.getData().y),
        Math.round(this.cropper.getData().width),
        Math.round(this.cropper.getData().height),
        Math.round(this.rotation),
        Math.round(this.imageCanvas.width),
        Math.round(this.imageCanvas.height),
        this.type
      );
      this.$emit("onPictureUpload", pic);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.uploader {
  display: none;
  position: fixed;
  &.open {
    display: grid;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    z-index: 500;
    display: grid;
    align-items: top;
    justify-items: center;
    grid-gap: 10px;
    grid-auto-rows: min-content;
  }
}

input[type="file"] {
  display: none;
}

#boutonUpload {
  display: inline-block;
}

.form1 {
  display: none;
}

.cadre {
  display: grid;
  grid-template-columns: min-content;
}

#uploadDialog {
  display: grid;
  grid-template-columns: min-content;
  .contenu {
    margin-top: 50px;
    background-color: white;
    padding: 5px;
    border: $light_border;
    display: grid;
    grid-auto-rows: min-content;
    grid-gap: 6px;
  }
}

#uploadDialog #form1 {
  margin-top: 0px;
}

#boutonsUpload {
  display: grid;
  grid-template-columns: auto auto max-content;
}

#uploadDialog #canvasProfil,
#uploadDialog .jcrop-holder {
  margin: 0 auto;
  z-index: 10;
  display: block;
  border: 1px #ccc solid;
  margin-top: 11px;
}

#paysageWarning {
  font-size: 14px;
  font-style: italic;
  padding: 5px;
  background: #e3e6ad !important;
  border: $light_border;

  img {
    vertical-align: middle;
  }
}

#icones {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  align-items: center;
  justify-content: end;
  grid-gap: 10px;

  a {
    cursor: pointer;
    img {
      left: 0px;
      top: 0px;
      &.enabled {
        filter: brightness(0);
      }
    }
  }
}

#boutonEnvoi {
  padding-top: 6px;
  padding-bottom: 6px;
}

.voileNoir {
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0.8;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #1d1b1a;
}
</style>
